import type { WLatestBlogPostsTranslations } from "./pl";

export const en: WLatestBlogPostsTranslations = {
  readMore: "Read more",
  showAll: "Show all",
};
